// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetView/FieldsConfiguration/fieldConfiguration.css
// module id = 2255
// module chunks = 0